import { axios } from '@/utils/request'

const api = {
  Pre: '/teacher.php/Subscribe/pre',
  List: '/teacher.php/Subscribe/getList',
  SaveMn: '/teacher.php/Subscribe/saveMn',
  SaveReport: '/teacher.php/Subscribe/saveReport',
  SaveHgpath: '/teacher.php/Subscribe/saveHgpath',
  Feijiaobooktime: '/teacher.php/Subscribe/feijiaobooktime',
  Feijiaobookth: '/teacher.php/Subscribe/feijiaobookth',
  Oumeibooktime: '/teacher.php/Subscribe/oumeibooktime',
  Oumeibookth: '/teacher.php/Subscribe/oumeibookth',
  Zuowenbook: '/teacher.php/Subscribe/zuowenbook',
  ChangePlan: '/teacher.php/Subscribe/changeplan',
  Yuyue: '/teacher.php/Subscribe/yuyue',
  Signfor: '/teacher.php/Subscribe/signfor',
  CheckProgress: '/teacher.php/Subscribe/checkProgress'
}

// 预加载
export function getPre () {
  return axios({
    url: api.Pre,
    method: 'get'
  })
}

export function getList (parameter) {
  return axios({
    url: api.List,
    method: 'get',
    params: parameter
  })
}

export function saveMn (parameter) {
  return axios({
    url: api.SaveMn,
    method: 'post',
    data: parameter
  })
}

export function saveReport (parameter) {
  return axios({
    url: api.SaveReport,
    method: 'post',
    data: parameter
  })
}

export function saveHgpath (parameter) {
  return axios({
    url: api.SaveHgpath,
    method: 'post',
    data: parameter
  })
}

export function feijiaobooktime (parameter) {
  return axios({
    url: api.Feijiaobooktime,
    method: 'get',
    params: parameter
  })
}

export function feijiaobookth (parameter) {
  return axios({
    url: api.Feijiaobookth,
    method: 'get',
    params: parameter
  })
}

export function oumeibooktime (parameter) {
  return axios({
    url: api.Oumeibooktime,
    method: 'get',
    params: parameter
  })
}

export function oumeibookth (parameter) {
  return axios({
    url: api.Oumeibookth,
    method: 'get',
    params: parameter
  })
}

export function zuowenbook (parameter) {
  return axios({
    url: api.Zuowenbook,
    method: 'get',
    params: parameter
  })
}

export function changePlan (parameter) {
  return axios({
    url: api.ChangePlan,
    method: 'post',
    data: parameter
  })
}

export function yuYue (parameter) {
  return axios({
    url: api.Yuyue,
    method: 'post',
    data: parameter
  })
}

export function saveSignfor (parameter) {
  return axios({
    url: api.Signfor,
    method: 'post',
    data: parameter
  })
}

export function checkProgress (parameter) {
  return axios({
    url: api.CheckProgress,
    method: 'get',
    params: parameter
  })
}
